import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { jwtPayload } from "atoms/auth";
import { UserDataForItercomDto } from "api/models/authServiceModels";
import Hotjar from "./Hotjar";
import Sentry from "lib/sentry/init";
import { getUserDataForUserTracking } from "api/services/authService";

const UserTracking = () => {
  const location = useLocation();
  const payload = useRecoilValue(jwtPayload);
  const [userInfo, setUserInfo] = useState<UserDataForItercomDto | undefined>();

  useEffect(() => {
    if (payload) {
      getUserDataForUserTracking().then(userData => {
        setUserInfo(userData);
      });

      Sentry.setUser({
        id: payload.userId
      });
    } else {
      setUserInfo(undefined);
    }
  }, [location, payload, setUserInfo]);

  return (
    <>
      <Hotjar userData={userInfo} />
    </>
  );
};

export default UserTracking;
